import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Program } from '../../shared/models/programs';

@Injectable({
  providedIn: 'root'
})
export class ProgramsService {

  programsCollection: AngularFirestoreCollection<Program>;
  programDoc: AngularFirestoreDocument<Program>;
  programs: Observable<Program[]>;
  program: Observable<Program>;

  constructor(private afs: AngularFirestore) {
    this.programsCollection = this.afs.collection('programs');
  }

  getPrograms(): Observable<Program[]> {
    return this.programsCollection.valueChanges({ idField: 'id'})
  }

  newProgram(program: Program): Promise<{ program: Program } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewProgram = await this.programsCollection.add(
          JSON.parse(JSON.stringify(program))
        );
        resolve(savingNewProgram.id);
      } catch (err) {
        reject(err);
      }
    });
  }

  getProgram(id: string): Observable<Program> {
    this.programDoc = this.afs.doc<Program>(`programs/${id}`);
    this.program = this.programDoc.snapshotChanges().pipe(
      map((action) => {
        if (action.payload.exists === false) {
          return null;
        } else {
          const data = action.payload.data() as Program;
          data.id = action.payload.id;
          return data;
        }
      })
    );
    return this.program;
  }

  async updateProgram(
     docId: string,
     newData: any
   ): Promise<{ program: Program } | any> {
     try {
       let response = await this.afs.doc(`programs/${docId}`).update(newData);
       return response;
     } catch (error) {
       console.log(error);
     }
  }

  async deleteProgram(
      docId: string
    ): Promise<{ program: Program } | any> {
    try {
      let response = await this.afs.doc(`programs/${docId}`).delete();
      return response;
    } catch (error) {
      console.log(error);
    }
  }

}
